/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：750
 */

module.exports = {
  container: "Notice_container__6Feqw",
  error: "Notice_error__1kxwP",
  warn: "Notice_warn__2t0LW",
  message: "Notice_message__3wDPL",
  close: "Notice_close__2EqRU",
  icon: "Notice_icon__1LJza"
}
